import { CalendarEvent } from "shared";

import { Event, EventType } from "@/types/events";

/**
 * Maps group IDs to human-readable group names
 *
 * @param groupId - The group identifier
 * @returns Human-readable group name
 */
function getGroupName(groupId: string): string {
  const groupNames: Record<string, string> = {
    "400B": "Troop 400B",
    "400G": "Troop 400G",
    cubscouts: "Pack 400",
  };
  return groupNames[groupId] ?? groupId;
}

/**
 * Transforms a CalendarEvent (Firestore) to an Event (UI type)
 *
 * @param calendarEvent - The calendar event from Firestore
 * @param eventType - The event type category
 * @returns Transformed Event object for UI components
 *
 * @example
 * const uiEvent = calendarEventToEvent(firestoreEvent, 'ceremony');
 */
export function calendarEventToEvent(
  calendarEvent: CalendarEvent,
  eventType: EventType,
): Event {
  return {
    id: calendarEvent.id,
    title: calendarEvent.title,
    description: calendarEvent.description ?? "",
    startDate: calendarEvent.startDate.toDate(),
    endDate: calendarEvent.endDate?.toDate(),
    startTime: calendarEvent.startTime,
    endTime: calendarEvent.endTime,
    location: calendarEvent.location ?? "Location TBD",
    audience: "TBD", // Not stored in CalendarEvent, provide fallback
    type: eventType,
    group: calendarEvent.groupId,
    groupName: getGroupName(calendarEvent.groupId),
  };
}
